import React, { Fragment } from 'react';
import styled from 'styled-components';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/card_table'. 'node_modules/@grnhse/seedling/lib/azalea/components/card_table.js' implicitly has an 'any' type.
import CardTable from '@grnhse/seedling/lib/azalea/components/card_table';

type Props = {
  headers: Array<any>;
  hide?: boolean;
};

export default function TableHeader(props: Props) {
  const { headers, hide } = props;
  return (
    <thead>
      <tr>
        {!hide && (
          <Fragment>
            {headers.map(({ key, label, width }) => (
              <LeftHeader key={key} width={width}>
                {label}
              </LeftHeader>
            ))}
          </Fragment>
        )}
      </tr>
    </thead>
  );
}

const LeftHeader = styled(CardTable.HeaderCell)`
  &:last-child {
    padding: 0 0 0 25px;
    vertical-align: top;
  }
`;
